import type { PermissionKey } from '@/types';

export function hasPermission(
  userPermissions: PermissionKey[] | string[] | undefined,
  required: PermissionKey | PermissionKey[],
): boolean {
  if (!userPermissions || userPermissions.length === 0) return false;
  const perms = new Set(userPermissions as string[]);
  const list = Array.isArray(required) ? required : [required];
  return list.every((p) => perms.has(p));
}

export function hasAnyPermission(
  userPermissions: PermissionKey[] | string[] | undefined,
  required: PermissionKey[],
): boolean {
  if (!userPermissions || userPermissions.length === 0) return false;
  const perms = new Set(userPermissions as string[]);
  return required.some((p) => perms.has(p));
}

export function hasRole(userRoles: string[] | undefined, required: string | string[]): boolean {
  if (!userRoles || userRoles.length === 0) return false;
  const roles = new Set(userRoles);
  const list = Array.isArray(required) ? required : [required];
  return list.some((r) => roles.has(r));
}
